export enum AbutmentTypes {
	CustomAbutment = 1,
	ScrewRetainedCrown = 2
};